import * as consts from "../constatnts/user_constants";


function loginUserReducer(state = {}, action) {
    switch (action.type) {
      case consts.LOGIN_USER_REQUEST:
        return { loading: true };
      case consts.LOGIN_USER_SUCCESS:
        return { loading: false, user: state ,success:true};
      case consts.LOGIN_USER_FAILURE:
        return { loading: false, error: action.payload,success:false };
        case consts.LOGOUT_USER:
          localStorage.removeItem('user')
            return {}
      default: return state;
    }
  }


  export {loginUserReducer}